import { ObjectiveStateResourceType } from '../resources/ObjectiveState';

let FINAL_STRETCH_THRESHOLD = 5;

function getBallotKeyToCategoryKey(
  ballotShape: Record<string, { options: Record<string, any> }>,
) {
  let map: Record<string, string> = {};
  for (let [ballotKey, section] of Object.entries(ballotShape)) {
    let firstOption = Object.values(section.options)[0];
    if (firstOption?.data?.categoryKey) {
      map[ballotKey] = firstOption.data.categoryKey;
    }
  }
  return map;
}

export function getSortedCategoryKeys<T extends string>({
  keys,
  objectiveState,
  previousYearResultOrder,
}: {
  keys: T[];
  objectiveState: ObjectiveStateResourceType;
  previousYearResultOrder: string[];
}): { announced: T[]; unannounced: T[] } {
  let categoryKeyOf = getBallotKeyToCategoryKey(objectiveState.ballotShape);
  let announcedCategories = objectiveState.results.map(
    item => Object.keys(item)[0],
  );

  let byReverseAnnouncement = (a: string, b: string) =>
    announcedCategories.indexOf(categoryKeyOf[b]) - announcedCategories.indexOf(categoryKeyOf[a]);

  let isAnnounced = (k: string) => announcedCategories.includes(categoryKeyOf[k]) || !categoryKeyOf[k];

  if (objectiveState.didCeremonyEnd) {
    return { announced: keys.toSorted(byReverseAnnouncement), unannounced: [] };
  }

  if (objectiveState.didCeremonyStart) {
    let announced = keys.filter(isAnnounced).toSorted(byReverseAnnouncement);
    let unannounced = keys.filter(k => !isAnnounced(k)).toSorted((a, b) =>
      previousYearResultOrder.indexOf(categoryKeyOf[a]) - previousYearResultOrder.indexOf(categoryKeyOf[b]),
    );
    return { announced, unannounced };
  }

  return { announced: [], unannounced: keys };
}

export { FINAL_STRETCH_THRESHOLD };
